import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';

import { PageAction } from '../../../components/page-actions/page-actions.component';
import { Models } from '@ibexfusion/models';
import { RedirectLogService } from '@services/redirects/redirect-log.service';
import { DataTableComponent, DataTableEvent } from '../../../components/data-table/data-table.component';

@Component({
    selector: 'app-redirect-log',
    templateUrl: './redirect-log.component.html',
    styleUrls: ['./redirect-log.component.scss'],
    providers: [RedirectLogService],
    standalone: false
})
export class RedirectLogComponent implements OnInit {

  public pageActions: PageAction[];

  public title = 'Redirect Log';

  public screens: Screen[];

  public customers: Models.Customer[];

  public isLoading = false;

  public lineChartLabels: Array<any> = [];
  public lineChartDataDayCount: Array<any> = [];

  public lineChartOptions: any = {
    chart: {
      type: 'line',
      height: 350
    },
    stroke: {
      curve: 'straight',
      width: 3,
    },
    grid: {
      padding: {
        right: 30,
        left: 20,
      },
    },
  };

  public range;
  public startDate;
  public endDate;
  public visitCounter = 0;
  public dates = [];

  public info = {
    android: { count: 0 },
    iphone: { count: 0 },
    ipad: { count: 0 },
    windows: { count: 0 },
    macintosh: { count: 0 },
    other: { count: 0 }
  };
  public barChartOptions: any = {
    chart: {
      type: 'bar',
      height: 350,
    },
    plotOptions: {
      bar: {
        horizontal: false
      }
    },
    title: {
      text: 'Devices',
      align: 'left',
    }
  };

  public columns = [
    { prop: 'redirectId', name: 'RedirectId' },
    { prop: 'userAgent', name: 'UserAgent' },
    {
      prop: 'created', name: 'created', valueTransformer: function(date) {
        return moment(date).format('DD-MM-YYYY  HH:mm');
      }
    },
  ];

  public params: any;

  @ViewChild(DataTableComponent) dataTable: DataTableComponent;

  constructor(
    private route: ActivatedRoute,
    public redirectLogService: RedirectLogService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.isLoading = true;
    this.params = {
      redirectId: this.route.snapshot.params['id']
    };
    this.params['$sort'] = { created: -1 };
    this.range = 50;
    this.initChart();
    this.createPageActions();
  }

  public onDetail(event: DataTableEvent) {
    this.router.navigate(['redirects/log', event.row._id]);
  }

  async initChart() {
    this.endDate = new Date();
    this.startDate = new Date();
    const dateCounter = new Date();
    this.startDate.setDate(this.endDate.getDate() - this.range);
    dateCounter.setDate(this.endDate.getDate() - this.range);
    for (let index = 0; index <= this.range; index++) {
      this.lineChartLabels[index] = moment(dateCounter).format('DD-MM-YY');
      this.dates[index] = dateCounter.setDate(dateCounter.getDate());
      this.lineChartDataDayCount[index] = 0;
      dateCounter.setDate(dateCounter.getDate() + 1);
    }
    await this.getData(this.range, 0);
    this.lineChartOptions.series = [
      {
        name: 'Day Count',
        data: this.lineChartDataDayCount
      }
    ];
    this.lineChartOptions.labels = this.lineChartLabels;

    this.barChartOptions.series = [
      {
        data: [{
          x: 'Android',
          y: this.info.android.count
        }, {
          x: 'Iphone',
          y: this.info.iphone.count
        }, {
          x: 'Ipad',
          y: this.info.ipad.count
        }, {
          x: 'Windows',
          y: this.info.windows.count
        }, {
          x: 'Macintosh',
          y: this.info.macintosh.count
        }, {
          x: 'Others',
          y: this.info.other.count
        }]
      }
    ];
  }

  async getData(index: number, skip: number) {
    await this.redirectLogService.find(skip, 100, { redirectId: this.route.snapshot.params['id'], $sort: { created: -1 } })
      .then(result => {
        if (index < 0 || !result.data.length || new Date(result.data[0].created) < this.startDate) {
          this.isLoading = false;
          return;
        }
        result.data.map(entry => {
          const entryDate = new Date(entry.created);
          while (index > 0 && moment(this.dates[index]).isAfter(entryDate, 'day')) {
            index--;
          }
          if (index > 0 && !moment(this.dates[index]).isSame(entryDate, 'day')) {
            index--;
          }
          if (moment(this.dates[index]).isSame(entryDate, 'day')) {
            this.lineChartDataDayCount[index] += 1;
            this.visitCounter++;
            if (entry.userAgent.match(/Android/gi)) {
              this.info.android.count++;
            } else if (entry.userAgent.match(/iPhone/gi)) {
              this.info.iphone.count++;
            } else if (entry.userAgent.match(/iPad/gi)) {
              this.info.ipad.count++;
            } else if (entry.userAgent.match(/Windows/gi)) {
              this.info.windows.count++;
            } else if (entry.userAgent.match(/Macintosh/gi)) {
              this.info.macintosh.count++;
            } else {
              this.info.other.count++;
              console.log(entry.userAgent);
            }
          }
        });
        this.getData(index, skip + 100);
      });
  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({
        icon: 'transform',
        title: 'Create New Redirect',
        callback: () => {
          this.router.navigate(['redirects/create']);
        }
      })
    ];
  }

}
